import React from "react" ;

const LetterboxAppQuickMenu = (props) =>
{
    return (
        <div className="quick-menu-list d-md-none">

            { /* Search Box */}
            <form className="search-box d-md-none">
                <input className="form-control" type="search" id="address" name="address"
                       placeholder="Search in app..."/>
                <button type="submit" className="search-icon"><i
                    className="icon icon-search icon-lg"/></button>
            </form>

            <a href="#" className="quick-menu d-none d-md-block text-muted"
               data-toggle="mdrawer" data-target="#drawer-search-bar"><i
                className="icon icon-search"/></a>
            <a href="#" className="quick-menu text-muted" data-open="compose"><i
                className="icon icon-edit"/></a>
            <a href="#" className="quick-menu text-muted" data-toggle="mdrawer"
               data-target="#drawer-notifications"><i className="icon icon-notification"/></a>
            <a href="#" className="quick-menu d-md-none text-muted"
               data-toggle="msidebar-content"><i className="icon icon-menu"/></a>
        </div>
    ) ;
}

export default LetterboxAppQuickMenu;
